export const SearchResultsContainer = ({
  isLoading = false,
  hasNoResults = false,
  layout = 'grid',
  children,
}) => {
  return (
    <div className={isLoading ? 'container--loading' : 'container--search-results'}>
      <div
        className={`${layout} search__results ${hasNoResults ? 'search__results--no-results' : ''}`}>
        {children}
      </div>
    </div>
  )
}
